import { FC } from "react";
import { CloseButtonProps } from "node_modules/react-toastify/dist/components";
import { Slide, ToastContainer } from "react-toastify";

const CloseButton: FC<CloseButtonProps> = ({ closeToast }) => (
    <button className="toastClose" onClick={closeToast}>
        <picture>
            <source srcSet="/images/modal/closemobile.svg" width={7.5} height={7.5} media="(max-width: 3840px)" />
            <img height={12} width={12} src="/images/modal/close.svg" style={{ opacity: 0.4 }} alt="Close modal" />
        </picture>
    </button>
);

const Toast: FC = () => {
    return (
        <ToastContainer
            toastClassName="toast"
            bodyClassName="toastBody"
            className="toastContainer"
            progressClassName="toastProgress"
            closeButton={CloseButton}
            position="bottom-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            draggable
            pauseOnHover={false}
            pauseOnFocusLoss={false}
            theme="dark"
            transition={Slide}
        />
    );
};

export default Toast;
